import { render, staticRenderFns } from "./ZoomDocumentation.vue?vue&type=template&id=5a6d4661&"
import script from "./ZoomDocumentation.vue?vue&type=script&lang=js&"
export * from "./ZoomDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ZoomDocumentation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports